// extracted by mini-css-extract-plugin
export default {"fr-view":"Questions_fr-view__sE9W2","question":"Questions_question__YSy+a"};